import React from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import { createTheme, ThemeProvider } from '@material-ui/core/styles'
import MomentUtils from '@date-io/moment'
import DynamicReducerProvider from '../commons/Redux/DynamicReducerProvider'
import Main from '../Main'

const theme = createTheme({
    palette: {
        primary: {
            main: '#124256',

        },
        secondary: {
            main: 'rgba(0, 0, 0, 0.87)',
        },
        text: {
            disabled: "rgba(0, 0, 0, 0.65)",
            hint: "rgba(0, 0, 0, 0.38)",
            primary: "rgba(0, 0, 0, 0.87)",
            secondary: "rgba(0, 0, 0, 0.87)",
        },
        action: {
            disabled: "rgba(0, 0, 0, 0.65)",
        }
    }
})

export default (props) =>
    <Provider store={props.store}>
        <DynamicReducerProvider dynamicReducer={props.dynamicReducer}>
            <ThemeProvider theme={theme}>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                    <HelmetProvider>
                        <BrowserRouter basename="/pss"> 
                            <Main {...props} />
                        </BrowserRouter>
                    </HelmetProvider>
                </MuiPickersUtilsProvider>
            </ThemeProvider>
        </DynamicReducerProvider>
    </Provider>
